import automated from './images/png/automated.png';
import client from './images/png/client.png';
import delivery from './images/png/delivery.png';
import equity from './images/png/equity.png';
import involvment from './images/png/involvment.png';
import multiple from './images/png/multiple.png';
import polymer from './images/png/polymer.png';
import steel from './images/png/steel.png';
import seller from './images/png/seller.png';
import buyer from './images/png/buyer.png';
import user from './images/png/user.png';
import polymerBlog from './images/png/polymerBlog.png';
import steelBlog from './images/png/steelBlog.png';
import polymerOriginal from './images/png/polymer-original.png';
import brandimg from './images/png/brand-img.png';
import cloud from './images/png/cloud.png';
import cart from './images/png/cart.png';
import deleteupload from './images/png/delete-upload.png';
import descriptionupload from './images/png/description-upload.png';
import aboutdetailsimg from './images/png/about_banner.jpg';
import career from './images/png/career.png';
import careershap from './images/png/career-shap.png';
import CheckedWhiteBg from './images/png/icon-park-solid_check-one.png';

const Png = {
      automated,
      client,
      delivery,
      equity,
      involvment,
      multiple,
      polymer,
      steel,
      user,
      seller,
      buyer,
      polymerBlog,
      steelBlog,
      polymerOriginal,
      brandimg,
      cart,
      cloud,
      deleteupload,
      descriptionupload,
      aboutdetailsimg,
      career,
      careershap,
      CheckedWhiteBg,
}

export default Png;